import React from 'react';
import { useSelector } from 'react-redux';

import {
  Recommendations,
  AssistantCTAPage,
} from 'modules/assistant/components/Assistant';

const AssistantManager = () => {
  const userData: UserProfileDTO = useSelector(
    (state: any) => state.user.current
  );

  return userData?.initialAssessment ? (
    <Recommendations />
  ) : (
    <AssistantCTAPage />
  );
};

export default AssistantManager;
